import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate, useParams } from 'react-router';
import { getTabLabelByLink, tabLowerCase } from '@/helpers/utils';
import useAppLanguage from '@/hooks/useAppLanguage';
import titleService from '@/services/titleService';
import AffectedVehiclesHelpText from './AffectedVehiclesHelpText/AffectedVehiclesHelpText';
import AttachmentsHelpText from './AttachmentsHelpText/AttachmentsHelpText';
import ClassificationHelpText from './ClassificationHelpText/ClassificationHelpText';
import DescriptionHelpText from './DescriptionHelpText/DescriptionHelpText';
import FeedbackHelpText from './FeedbackHelpText/FeedbackHelpText';
import HardwareHelpText from './HardwareHelpText/HardwareHelpText';
import PlantFeedbackHelpText from './PlantFeedbackHelpText/PlantFeedbackHelpText';
import RecipientsHelpText from './RecipientsHelpText/RecipientsHelpText';
import SoftwareHelpText from './SoftwareHelpText/SoftwareHelpText';
import Summary from './SummaryHelpText/SummaryHelpText';
import SummaryPlantFeedbackHelpText from './SummaryPlantFeedbackHelpText/SummaryPlantFeedbackHelpText';
import TranslationsHelpText from './TranslationsHelpText/TranslationsHelpText';

const HelpText = () => {
  const { t } = useTranslation();
  const lang = useAppLanguage();
  const { helpTab } = useParams();

  useEffect(() => {
    const tab = `navTab.${getTabLabelByLink(tabLowerCase(helpTab))}`;
    titleService.updatePageTitle(t('dashboard.administration'), `${t('administration.help')} ${t(tab)}`);
  }, [t, helpTab, lang]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="description" replace />} />
      <Route path="description" element={<DescriptionHelpText />} />
      <Route path="attachments" element={<AttachmentsHelpText />} />
      <Route path="classification" element={<ClassificationHelpText />} />
      <Route path="affected-hardware" element={<HardwareHelpText />} />
      <Route path="affected-software" element={<SoftwareHelpText />} />
      <Route path="affected-vehicles" element={<AffectedVehiclesHelpText />} />
      <Route path="translations" element={<TranslationsHelpText />} />
      <Route path="recipients" element={<RecipientsHelpText />} />
      <Route path="summary" element={<Summary />} />
      <Route path="feedback" element={<FeedbackHelpText />} />
      <Route path="summary-feedback" element={<PlantFeedbackHelpText />} />
      <Route path="summary-plant-feedback" element={<SummaryPlantFeedbackHelpText />} />
      <Route path="*" element={<Navigate to="description" replace />} />
    </Routes>
  );
};

export default HelpText;
